// v1.2.0 - 2026-02-02 - Added EnergyDataBrowser and ConfigurationDetail routes

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/lib/stores/authStore'
import { BrandedWrapper } from '@/components/layout/BrandedWrapper'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { MemberLayout } from '@/components/layout/MemberLayout'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'

// Pages
import LoginPage from '@/pages/auth/LoginPage'
import AdminDashboard from '@/pages/admin/DashboardPage'
import MembersPage from '@/pages/admin/MembersPage'
import MemberDetailPage from '@/pages/admin/MemberDetailPage'
import ConfigurationsPage from '@/pages/admin/ConfigurationsPage'
import { ConfigurationDetail } from '@/pages/admin/configurations/ConfigurationDetail'
import UploadPage from '@/pages/admin/UploadPage'
import CalculationsPage from '@/pages/admin/CalculationsPage'
import CalculationDetailPage from '@/pages/admin/calculations/CalculationDetailPage'
import EnergyDataBrowser from '@/pages/admin/EnergyDataBrowser'
import SettingsPage from '@/pages/admin/SettingsPage'
import ReportsPage from '@/pages/admin/ReportsPage'
import MemberDashboard from '@/pages/member/DashboardPage'
import MemberEarnings from '@/pages/member/EarningsPage'
import MemberEnergy from '@/pages/member/EnergyPage'
import MemberDocuments from '@/pages/member/DocumentsPage'

function AppRoutes() {
  const { user, isAuthenticated, cerSettings, logout } = useAuthStore()

  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<LoginPage />} />

      {/* Admin Routes */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute requiredRole="admin">
            <AdminLayout
              user={user!}
              cerSettings={cerSettings}
              onLogout={logout}
            />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="members" element={<MembersPage />} />
        <Route path="members/:memberId" element={<MemberDetailPage />} />
        <Route path="configurations" element={<ConfigurationsPage />} />
        <Route path="configurations/:configId" element={<ConfigurationDetail />} />
        <Route path="energy-data" element={<EnergyDataBrowser />} />
        <Route path="upload" element={<UploadPage />} />
        <Route path="calculations" element={<CalculationsPage />} />
        <Route path="calculations/:calcId" element={<CalculationDetailPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="reports" element={<ReportsPage />} />
      </Route>

      {/* Member Routes */}
      <Route
        path="/member"
        element={
          <ProtectedRoute requiredRole="member">
            <MemberLayout
              user={user!}
              cerSettings={cerSettings}
              onLogout={logout}
            />
          </ProtectedRoute>
        }
      >
        <Route index element={<MemberDashboard />} />
        <Route path="earnings" element={<MemberEarnings />} />
        <Route path="energy" element={<MemberEnergy />} />
        <Route path="documents" element={<MemberDocuments />} />
      </Route>

      {/* Root redirect */}
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Navigate to={user?.role === 'admin' ? '/admin' : '/member'} replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default function App() {
  const { cerSettings } = useAuthStore()

  return (
    <BrowserRouter>
      <BrandedWrapper settings={cerSettings}>
        <AppRoutes />
      </BrandedWrapper>
    </BrowserRouter>
  )
}
